var supportedLanguages;
export var getSupportedLanguages = function getSupportedLanguages() {
  if (!supportedLanguages) {
    supportedLanguages = Oskari.getSupportedLanguages();
  }
  return supportedLanguages;
};